import "../../../css/Containers/ContainerStyles.css";
import { Icon } from "@iconify/react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

type ConfirmDiscardChangesModalProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  deleteOnPress: () => Promise<void> | void;
};

// Builds off of ConfirmDeleteModal to display discarding changes confirmation modal
const ConfirmDiscardChangesModal = (props: ConfirmDiscardChangesModalProps) => {
  const { isVisible, setIsVisible, deleteOnPress } = props;

  return (
    <ConfirmDeleteModal
      heading="Are you sure you want to exit?"
      subtext="Your changes won't be saved. This cannot be undone."
      deleteButtonText="Exit"
      hideModal={!isVisible}
      setIsVisible={setIsVisible}
      deleteOnPress={deleteOnPress}
      icon={<Icon icon="ion:exit-outline" height={40} />}
    />
  );
};

export default ConfirmDiscardChangesModal;
